<div class="message-outer" *ngIf="text">
  <post-text [text]="text" [expanded]="expanded"></post-text>
</div>